import {
  scrollLockTimeoutMs,
} from './chatSettings';

const temporaryScrollLockTo = (dispatch, isMountedRef) => {
  dispatch({ type: 'lockScroll' });
  setTimeout(
    () => { if (isMountedRef.current) dispatch({ type: 'endLockScroll' }); },
    scrollLockTimeoutMs,
  );
};

export default temporaryScrollLockTo;
